import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL SIZES
export const sizeList = (params = '') => Http.get(`/marketing-ad-sizes${serialize(params)}`)
export const sizeCreate = (params = '') => Http.post('/marketing-ad-sizes', params)
export const sizeByID = (params = '') => Http.get(`/marketing-ad-sizes/${params}`)
export const sizeUpdate = (params = '') => Http.put(`/marketing-ad-sizes/${params.id}`, params)
export const sizeDestroy = (params = '') => Http.delete(`/marketing-ad-sizes/${params.id}`)
